import { inject, observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import Play from "components/Play";
import IssueDialog from "components/IssueDialog";
import Loading from "components/Loading";
import PlayPaginationBar from "containers/PlayPaginationBar";

const Container = styled.div`
  grid-area: catalog;
  height: calc(~"100vh -" 200px);
`;

const PlaysContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
  padding: 10px 25px;
`;

class PlayCatalog extends React.Component {
  render() {
    const { videoSearchStore } = this.props;

    return (
      <Container>
        <PlayPaginationBar />
        {videoSearchStore.isLoading ? (
          <Loading />
        ) : (
          <PlaysContainer>
            {videoSearchStore.plays.length === 0 ? (
              <div>No videos found :( </div>
            ) : (
              videoSearchStore.plays.map((p, i) => (
                <Play key={i} play={p} query={videoSearchStore.query} />
              ))
            )}
          </PlaysContainer>
        )}
        <IssueDialog />
      </Container>
    );
  }
}

export default inject("videoSearchStore")(observer(PlayCatalog));



// WEBPACK FOOTER //
// ./src/sections/PlayCatalog.js